export enum LanguageEnum {
    English = 'en-US',
    Malay = 'ms-MY',
}
